/*
 * ALL RIGHTS RESERVED,
 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
 */

import { PjErrorInfo } from '../../extends_fw/service/PjErrorInfo';
import { PjBaseService } from '../../extends_fw/service/PjBaseService';
import { PjServiceResponse } from '../../extends_fw/service/PjServiceResponse';
import { LocalityApi } from '../api/LocalityApi';
import { Locality } from '../model/Locality';
import { GetLocalityRes } from '../model/GetLocalityRes';

/**
 * 自治体に関するデータを管理するサービスである。
 */
export class LocalityService extends PjBaseService {

    /**
     * 自治体一覧
     */
    protected locality: Locality[];

    /**
     * コンストラクタ
     * @param {ng.IQService} $q 非同期サービス
     * @param {LocalityApi} localityApi 自治体Api
     */
    /* @ngInject */
    public constructor(
            protected $q: ng.IQService,
            protected localityApi: LocalityApi) {
        super(null);
    }

    /**
     * 自治体一覧取得
     * @return {ng.IPromise<PjServiceResponse<Locality[]>>} 通信結果のPromiseを返す。Promiseに渡されるデータは、図書館の一覧となる。
     */
    public getLocality(): ng.IPromise<PjServiceResponse<Locality[]>> {
        let deferred: ng.IDeferred<PjServiceResponse<Locality[]>> = this.$q.defer();

        if (!this.locality) {
              // キャッシュに格納されていなければ取得する
            // 同時にアクセスにきたことを考慮し、2重送信チェックを追加
            this.localityApi.localityGet(true).success((res: GetLocalityRes,
                status: number, headers: ng.IHttpHeadersGetter, config: ng.IRequestConfig) => {
                // キャッシュにデータを格納
                this.locality = res.localitys;
                deferred.resolve({ status: status, data: this.locality });
            }).error((data: PjErrorInfo, status: number, headers: ng.IHttpHeadersGetter, config: ng.IRequestConfig) => {
                deferred.reject({ status: status, error: data });
            });
        } else {
            // キャッシュから返す
            deferred.resolve({ status: 200, data: this.locality });
        }
        return deferred.promise;
    }

}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/common/locality/service/LocalityService.ts
 **/